import EnumClass, { build } from '../EnumClass';
import data, { PasswordTypeId } from './data';
import * as Translations from './translations';
import { List, Set } from 'immutable';

export enum CharacterType {
  Upper = 'upper',
  Lower = 'lower',
  Digit = 'digit',
  Special = 'special',
}

// This is loosely based on Apple's `passwordrules` proposal at
// https://developer.apple.com/password-rules/
const parsedData = data.map((item) => {
  const minLengthMatch = item.rule.match(/minlength: (\d+);/);
  if (!minLengthMatch || minLengthMatch.length < 2) {
    throw new Error('Password rules must include a valid minLength.');
  }
  const requiredMatch = item.rule.match(/required: ([\w\s,]+);/g);
  return ({
    enum_constant: item.enum_constant,
    fullRule: item.rule,
    minLength: Number(minLengthMatch[1]),
    required: requiredMatch ? List(requiredMatch.map((required) => {
      const matched = required.match(/required: ([\w\s,]+);/);
      if (!matched || matched.length < 2) {
        throw new Error('If a requirement exists, it must not be empty.');
      }
      return Set(matched[1].split(', ').map((charType) => {
        if (charType === CharacterType.Upper) {
          return CharacterType.Upper;
        } else if (charType === CharacterType.Lower) {
          return CharacterType.Lower;
        } else if (charType === CharacterType.Digit) {
          return CharacterType.Digit;
        } else if (charType === CharacterType.Special) {
          return CharacterType.Special;
        } else {
          throw new Error('Requirements must be a valid character type.');
        }
      }));
    })) : List([]),
  });
});

// Not using the generated data type since the data is being manipulated before being put into the enum class
export class PasswordType extends EnumClass<PasswordTypeId, typeof parsedData[number]> {
  public get getName() {
    return Translations.name[this.id];
  }

  public get fullRule() {
    return this.metadata.fullRule;
  }

  public get minLength() {
    return this.metadata.minLength;
  }

  public get required() {
    return this.metadata.required;
  }
}

export const {
  list: PASSWORD_TYPES,
  getById: getPasswordTypeById,
  marshaller: PasswordTypeMarshaller,
} = build<PasswordTypeId, typeof parsedData[number], PasswordType>('PasswordTypeEnum', parsedData, PasswordType);
